import { render, staticRenderFns } from "./BlockActionTrigger.vue?vue&type=template&id=81bdfa2e&"
import script from "./BlockActionTrigger.vue?vue&type=script&lang=js&"
export * from "./BlockActionTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports